import PropTypes from 'prop-types'
import React, { createContext, useState } from 'react'
import Theme from '../components/theme/theme'
import { useSelector } from 'react-redux'

export const DataContext = createContext({})

export const DataProvider = ({ children, languageSetter }) => {
  const brand = useSelector((state) => state.reducer.brand)

  const [data, setData] = useState({
    Theme: { theme: Theme() },
    brand,
    showLinearProgress: false,
    languageSetter,
    responsiveMenu: {
      clicked: false,
      directionClicked: '',
      directRoute: '',
      mainMenuOpen: false,
    },
    filtersData: { fromDetail: false },
  })

  return <DataContext.Provider value={{ data, setData }}>{children}</DataContext.Provider>
}

DataProvider.propTypes = {
  children: PropTypes.element.isRequired,
}
